import { datadogRum } from '@datadog/browser-rum';

export default class DatadogRUMManager {
    constructor() {
        this.initialize()
    }

    initialize() {
        document.addEventListener("DOMContentLoaded", () => {
            if (myApp.config.parameters.isOfficeView || myApp.config.parameters.isDev) {
                return;
            }

            const rumParameters = {
                applicationId: '1a45563a-f832-4e45-983c-a98fe7961857',
                clientToken: 'pub900172de37248d64c75982afe796a138',
                site: 'datadoghq.eu',
                service: 'buscounchollo-rum-prod',
                env: 'PROD',
                sessionSampleRate: window.datadogSampleRate ?? 1.5,
                sessionReplaySampleRate: window.datadogSampleRate ?? 10,
                defaultPrivacyLevel: 'allow',
            };
            datadogRum.init(rumParameters);
        });
    }
}